import { Box, Button, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import Modal from '../../../common/modal'
import { Item } from '../../../common/snippets'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import * as mdt from '../../../common/modaltypes'
import { useEffect, useState } from 'react'
import DropDownOA from '../../../common/dropDownOA'
import { isEmpty, navigation3, removeDuplicatesFromArray } from '../../../common/helper'
import { cargoServiceTypes, rateMatrixHistoryHeader } from './rateMatrixConstants'
import { getFocApprConsTypeData, getServiceTypeListAllData, kgKmRateMatrixUpdate } from '../../../../store/generalSetting/GSAction'
import { GetKgKmRateMatrixHistoryTblData } from '../../../../store/generalSetting/GSAction'
import { updateAlertError, updateModal } from '../../../../store/common/common_action'
import { connect, useDispatch } from 'react-redux'
import moment from 'moment'
import { useTranslation } from '../../../../i18n/I18nProvider'
const KgkmMatrixDelete = (props) => {
    const dispatch = useDispatch()
    const { data, methods, GetKgKmRateMatrixHistoryTblData, updateModal, getServiceTypeListAllData, getFocApprConsTypeData, kgKmRateMatrixUpdate, updateAlertError } = props
    const { tableData1 } = props
    const theme = useTheme()
    const { translations, language } = useTranslation()
    const gs = translations?.generalSettings || {}
    const t = (key, fallback) => gs?.[key] || fallback
    const cargoServiceTypeOptions = cargoServiceTypes.map((item) => ({ ...item, name: t(item.translationKey, item.name) }))
    const [selectedServiceType, setSelectedServiceType] = useState({})
    const { headText, isDelete = false, generalSettingReducer, common } = data
    const { loginData } = common
    const { focApprConsTypeData, kgKmRateMatrixData, kgKmRateMatrixHistoryData, serviceTypeListAll, serviceTypeListAll2 } = generalSettingReducer
    let rateMatrixHistoryHeaderCopy = rateMatrixHistoryHeader.map((col) => ({ ...col, headerName: t(col.translationKey, col.headerName) }));
    const [selectedData, setSelectedData] = useState({ cargoServiceType: cargoServiceTypeOptions[0], multiCargoServiceType: '', consType: '' })
    const [showResult, setShowResult] = useState(true)
    const [showTable, setShowTable] = useState(true)
    const [deleteHistoryData, setDeleteHistoryData] = useState([])
    const [consTypeList, setConsTypeList] = useState([])
    useEffect(() => {
        if (serviceTypeListAll2[0]?.CargoServiceTypeID === 0) {
            setSelectedData({ cargoServiceType: cargoServiceTypeOptions[0] })
        } else {
            setSelectedData({ cargoServiceType: cargoServiceTypeOptions[1] })
        }
    }, [serviceTypeListAll2])
    useEffect(() => {
        if (!isEmpty(loginData)) {
            let multiCargoBody = {
                CargoServiceType: selectedData?.cargoServiceType?.id,
                CompanyID: loginData?.intCompanyID,
                IsActive: 1
            }
            getServiceTypeListAllData(multiCargoBody)
        }
    }, [loginData, selectedData?.cargoServiceType])
    useEffect(() => {
        if (!isEmpty(loginData)) {
            let obj = {
                intConsignmentSubTypeID: 0,
                intCompanyID: loginData?.intCompanyID,
                intConsignmentTypeID: 0,
                strSubType: "",
                intIsActive: 1,
                intIsDeleted: 0
            }
            getFocApprConsTypeData(obj)
        }
    }, [loginData])
    useEffect(() => {
        if (serviceTypeListAll?.length > 0) {
            setSelectedData((prev) => ({
                ...prev,
                multiCargoServiceType: serviceTypeListAll[0]
            }))
        }
    }, [serviceTypeListAll])
    useEffect(() => {
        if (focApprConsTypeData?.length > 0) {
            let newData = [{ id: 0, name: t('all', 'All'), translationKey: 'all' }]
            focApprConsTypeData.map(function (obj) {
                newData.push({
                    id: obj.ConsignmentSubTypeID,
                    name: obj.SubType,
                })
            })
            newData = removeDuplicatesFromArray(newData, `id`)
            newData.sort((a, b) => a.name.localeCompare(b.name))
            setConsTypeList(newData)
            setSelectedData((prev) => ({
                ...prev,
                consType: newData.find((item) => item.id === prev?.consType?.id) || newData[0]
            }))
        } else {
            setConsTypeList([])
        }
    }, [focApprConsTypeData, translations])

    useEffect(() => {
        // if (kgKmRateMatrixHistoryData.length>0) {
        const updatedData = kgKmRateMatrixHistoryData?.map((val, index) => ({ ...val, SN: index + 1, EntryDateTime: moment(val.EntryDateTime).format('HH:mm DD MMM-YY') }))
        setDeleteHistoryData(updatedData)
        // }
    }, [kgKmRateMatrixHistoryData])

    if (isDelete) {
        rateMatrixHistoryHeaderCopy = rateMatrixHistoryHeaderCopy
            .filter((item) => item.field !== 'OldRate' && item.field !== 'OldDocumentCharge')
            .map((header) => {
                if (header.field === 'NewRate' || header.translationKey === 'newRate') {
                    return { ...header, headerName: t('rate', 'Rate'), translationKey: 'rate' };
                } else if (header.field === 'NewDocumentCharge' || header.translationKey === 'newDocChrg') {
                    return { ...header, headerName: t('docChargeShort', 'Doc. Charge'), translationKey: 'docChargeShort' };
                }
                return header;
            });
    }

    // const { updateModal } = methods
    const modalStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }

    const handleLoadBtn = () => {
        if (selectedData?.cargoServiceType === '') {
            updateAlertError({ show: true, msg: t('pleaseSelectCargoServiceType', 'Please Select Cargo Service Type'), success: false, nextId: `` })
        } else if (selectedData?.multiCargoServiceType === '') {
            updateAlertError({ show: true, msg: t('pleaseSelectMultiCargoServiceType', 'Please Select Multi Cargo Service Type'), success: false, nextId: `` })
        } else if (selectedData?.consType === '') {
            updateAlertError({ show: true, msg: t('pleaseSelectConsignmentType', 'Please Select Consignment Type'), success: false, nextId: `` })
        } else {
            const obj = {
                CompanyID: loginData?.intCompanyID,
                CargoServiceType: selectedData?.cargoServiceType?.id,
                ServiceTypeID: selectedData?.multiCargoServiceType?.ServiceTypeID,
                ConsignmentID: selectedData?.consType?.id
            }
            GetKgKmRateMatrixHistoryTblData(obj)
            setShowResult(true)
        }
    }
    const handleDeleteBtn = () => {
        const obj = {
            CompanyID: loginData?.intCompanyID,
            LoginUserID: loginData?.intUserID,
            ConsignmentIDs: '',
            FromKgs: '',
            ToKgs: '',
            FromKms: '',
            ToKms: '',
            Rates: '',
            ConsignmentID: selectedData.consType.id,
            Mode: 2,
            RateIDs: '',
            DocumentCharges: '',
            ServiceTypeIDs: '',
            ServiceTypeID: selectedData.multiCargoServiceType.ServiceTypeID,
            IsDocChgFixed: tableData1?.[0]?.IsDocChgFixed,
            FixedDocChg: tableData1?.[0]?.FixedDocChg
        }
        kgKmRateMatrixUpdate(obj).then((res) => {
            if (res?.status == 'Success') {
                //   setIsSuccess(true)
                updateAlertError({ show: true, msg: t('successfullyDeleted', 'Successfully Deleted'), success: false, nextId: `focApprConsType`, close: handleClose() })
                // handleLoadBtn()
            } else {
                updateAlertError({ show: true, msg: res.Message, success: false, nextId: `focApprConsType` })
            }
        }).catch((err) => {
            console.log("Error:", err)
        })
    }
    const handleClose = () => {
        updateModal(false, 'kg_kmg_rate_delete')
        updateAlertError({ show: false, msg: '' })
    }
    return (
        <Modal
            headTxt={headText || t('deleteKgKmMatrix', 'Delete KG-KM Matrix')}
            width={'95%'}
            updateModal={updateModal}
            height={'80%'}
            closeId={'closeButton'}
            modalClass={'booking-popup'}
            modalStyle={modalStyle}
        >
            <div style={{ position: 'relative', height: 'calc(100% - 53px)' }}>
                <Grid container sx={{ display: 'flex', gap: '16px', padding: '12px 15px 4px 15px' }}>
                    <Item sx={sx.itemsxGrow}>
                        <DropDownOA
                            id={'Cargo_Service_Type'}
                            label={t('cargoServiceType', 'Cargo Service Type')}
                            data={cargoServiceTypeOptions}
                            defaultvalue={selectedData?.cargoServiceType?.name || ''}
                            value={selectedData?.cargoServiceType?.name || ''}
                            onSelect={(val) => {
                                setShowResult(false)
                                setSelectedData((prev) => ({
                                    ...prev,
                                    cargoServiceType: val
                                }))
                            }}
                            disabled={true}
                            idKey={`id`}
                            dataKey={`name`}
                            minWidth={"100%"}
                            nextId={``}
                            prevId={``}
                            onSelResetVal={true}
                        />
                    </Item>
                    <Item sx={sx.itemsxGrow}>
                        <DropDownOA label={t('multiCargoServiceType', 'Multi Cargo Service Type')}
                            data={serviceTypeListAll || []}
                            defaultvalue={selectedData?.multiCargoServiceType?.ServiceType || ''}
                            value={selectedData?.multiCargoServiceType?.ServiceType || ''}
                            width="100%"
                            searchPlaceholder={t('searchServiceType', 'Search Service Type')}
                            dataKey={`ServiceType`}
                            idKey={`ServiceTypeID`}
                            listWidth="200px"
                            // resetFlag={resetFilter}
                            onSelect={(val) => {
                                setShowResult(false)
                                setSelectedData((prev) => ({
                                    ...prev,
                                    multiCargoServiceType: val
                                }))
                            }}
                            onSelResetVal={true}
                        />
                    </Item>
                    <Item sx={sx.itemsxGrow}>
                        <DropDownOA
                            key={`consignmentType-${language}-${selectedData?.consType?.id}-${selectedData?.consType?.name}`}
                            id='ConsType'
                            label={t('consignmentType', 'Consignment Type')}
                            data={consTypeList || []}
                            defaultvalue={selectedData?.consType?.name || ''}
                            value={selectedData?.consType?.name || ''}
                            width="100%"
                            searchPlaceholder={t('searchConsignmentType', 'Search Consignment Type')}
                            dataKey={`name`}
                            idKey={`id`}
                            listWidth="200px"
                            // resetFlag={resetFilter}
                            onSelect={(val) => {
                                setShowResult(false)
                                setSelectedData((prev) => ({
                                    ...prev,
                                    consType: val
                                }))
                            }}
                            nextId=''
                            prevId={``}
                            onSelResetVal={true}
                        />
                    </Item>
                    <Item sx={{ ...sx.itemsx, padding: 0 }} className="disabled-wrapper">
                        <Button
                            variant="contained"
                            onKeyDown={(e) => navigation3(e, 'add_btn', 'Select_Charge', () => { })}
                            id={'search_btn'}
                            sx={{ width: '100%', paddingY: '6px !important' }}
                            className="btn btn-primary"
                            onClick={() => handleLoadBtn()}
                        >
                            {t('load', 'Load')}
                        </Button>
                    </Item>
                </Grid>
                {
                    showResult &&
                    <>
                        <Grid container sx={{ paddingX: '15px', marginBottom: '10px', height: 'calc(100% - 120px)' }}>
                            <TableContainer component={Paper} className="scroll" sx={{ marginY: '5px', height: '100%' }}>
                                <Table
                                    id='table-to-xls'
                                    stickyHeader
                                    size="small"
                                    aria-label="a dense table"
                                    sx={{
                                        '& .MuiTableCell-root': {
                                            padding: '6px 4px !important',
                                        },
                                    }}
                                >
                                    <TableHead>
                                        <TableRow>
                                            {rateMatrixHistoryHeaderCopy.map((row, index) => {
                                                return (
                                                    <TableCell
                                                        sx={{
                                                            ...row.headerSx,
                                                            backgroundColor: '#DAEDFE',
                                                            height: '30px',
                                                            fontSize: '12px',
                                                            fontWeight: '600',
                                                            color: '#444',
                                                            fontSize: '12px',
                                                        }}
                                                    >
                                                        {row.headerName}
                                                    </TableCell>
                                                )
                                            })}
                                        </TableRow>
                                    </TableHead>
                                    {
                                        deleteHistoryData?.length < 1 ?
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell colSpan={15}>
                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                                justifyContent: 'center',
                                                                marginTop: '20px',
                                                                marginBottom: '20px',
                                                                color: 'red',
                                                                fontSize: '20px',
                                                                lineheight: '16px',
                                                                letterspacing: '0.24px',
                                                            }}
                                                        >
                                                            <span>{t('noResultsRefineSearch', 'No results found. Please refine your search parameters and search again.')}</span>
                                                        </div>
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody> :
                                            <TableBody>
                                                {deleteHistoryData.map((item, index) => (
                                                    <TableRow key={`DR-${index}`}>
                                                        {rateMatrixHistoryHeaderCopy.map((col) => (
                                                            <TableCell sx={{ ...col.headerSx, height: '29px', fontSize: '12px', fontWeight: '400' }}>{item[col.field]}</TableCell>
                                                        ))}
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                    }

                                </Table>
                            </TableContainer>
                        </Grid>
                        <Grid container sx={{ display: 'flex', gap: '16px', padding: '5px 15px 15px 15px', justifyContent: 'flex-end', position: 'absolute' }}>
                            <Item sx={{ ...sx.itemsx }} className="">
                                <Button
                                    variant="outlined"
                                    id={'add_btn'}
                                    color="secondary"
                                    sx={{ width: '100%', fontSize: '16px' }}
                                    className="receiveitembtn"
                                    onClick={() => {
                                        updateModal(true, mdt.PickupAndDropoffModal)
                                    }}
                                >
                                    {t('cancel', 'Cancel')}
                                </Button>
                            </Item>
                            <Item sx={{ ...sx.itemsx }} className="">
                                <Button
                                    variant="contained"
                                    id={'add_btn'}
                                    color="secondary"
                                    sx={{ width: '100%', fontSize: '16px' }}
                                    className="receiveitembtn"
                                    // onClick={() => {
                                    //   updateModal(true, mdt.PickupAndDropoffModal)
                                    // }}
                                    onClick={() => handleDeleteBtn()}
                                >
                                    {t('delete', 'Delete')}
                                </Button>
                            </Item>
                        </Grid>
                    </>
                }

            </div>
        </Modal>
    )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { updateModal, GetKgKmRateMatrixHistoryTblData, getServiceTypeListAllData, getFocApprConsTypeData, kgKmRateMatrixUpdate, updateAlertError }
export default connect(mapStateToProps, mapDispatchToProps)(KgkmMatrixDelete)